import {Bitmask} from "./modules/bitmask";
import {initSliders} from "./modules/slider";

document.body.classList.add("js"); // Lets styles know the user has JS enabled
const bsl = window.bodyScrollLock || false;
const lg = 992;

// #region Navigation
/**
 * Enables the click event to toggle the sidebar on mobile
 */
const initSidebarToggle = () => {
	const toggle = document.querySelector(".sidebar__toggle");
	const sidebar = document.querySelector(".sidebar");

	if (toggle) {
		toggle.addEventListener("click", function () {
			document.body.classList.toggle("sidebar--toggled");
			sidebar.classList.toggle("d-none");
		});
	}
};

/**
 * Enables the click event to toggle the header on mobile
 */
const initHeaderToggle = () => {
	const toggleClass = "header--toggled";
	const toggle = document.querySelector(".header__toggle");
	const avatar = document.querySelector(".header-avatar");
	const linkGroups = document.querySelectorAll(
		".header__mobile-links > .flex-column"
	);
	const header = document.querySelector(".header__mobile");
	const scrollable = document.querySelector(".header__scrollable");

	if (avatar && linkGroups.length) {
		avatar.addEventListener("click", function () {
			doToggle();
			linkGroups.forEach(function (links) {
				if (
					links.parentElement.classList.contains(
						"header__mobile--my-academy-links"
					)
				) {
					links.classList.add("d-flex");
					links.classList.remove("d-none");
				} else {
					links.classList.remove("d-flex");
					links.classList.add("d-none");
				}
			});
		});
	}

	// Don't add the event listener if it's parent portal.
	if (!AoPS.bd.usePPMobileMenu) {
		toggle.addEventListener("click", doToggle);
	}

	window.addEventListener("resize", function () {
		const isToggled = document.body.classList.contains(toggleClass);
		if (!isToggled) {
			return;
		}
		const isDesktop = window.innerWidth >= lg;

		if (isDesktop && bsl) {
			bsl.enableBodyScroll(scrollable);
		} else {
			if (bsl) {
				bsl.disableBodyScroll(scrollable);
			}
			doMobileGracePadding();
		}
	});

	/**
	 * Toggle the mobile menu
	 */
	function doToggle() {
		document.body.classList.toggle(toggleClass);
		if (document.body.classList.contains(toggleClass)) {
			if (bsl) {
				bsl.disableBodyScroll(scrollable);
			}
			doMobileGracePadding();
		} else if (bsl) {
			bsl.enableBodyScroll(scrollable);
		}
	}

	/**
	 * Because offsetTop changes on the mobile header when the main header nav
	 * becomes fixed, adjust the padding by the height of the offset
	 */
	function doMobileGracePadding() {
		let offset = header.offsetTop;
		if (window.scrollY < 1 && header.offsetParent) {
			offset += header.offsetParent.offsetTop;
		}
		header.style.paddingBottom = offset + 32 + "px";
	}
};

/**
 * Enables the click event to toggle the links in the mobile menu. Tapping on
 * touchscreen is the same as a click
 */
const initMobileLinkToggle = () => {
	const toggles = document.querySelectorAll(".header__mobile-link");
	for (const toggle of toggles) {
		toggle.addEventListener("click", () => {
			toggle.nextElementSibling.classList.toggle("d-none");
			toggle.nextElementSibling.classList.toggle("d-flex");
		});
	}
};

/**
 * Creates the event for allowing infobars to hide themselves
 */
const initInfobars = () => {
	document.querySelectorAll(".infobar .infobar-hide.bx-x").forEach((elem) => {
		const bar = elem.closest(".infobar");
		const key = encodeURIComponent(bar.dataset.key);

		elem.addEventListener("click", () => {
			bar.classList.add("d-none");
			const controller = new AbortController();
			const timeout = setTimeout(() => {
				controller.abort();
			}, 5000);

			fetch("/ajax.php", {
				method: "POST",
				headers: {
					"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
					"X-Requested-With": "XMLHttpRequest",
				},
				body: `a=infobar-hide&key=${key}`,
				signal: controller.signal,
			})
				.then((res) => {
					if (res.ok) {
						return;
					}
					console.error(res.status);
				})
				.catch(console.error)
				.finally(() => {
					clearTimeout(timeout);
				});
		});
	});
};

/**
 * Makes the header shrink when scrolling down the page and expand when
 * scrolling up/to the top
 */
const initHeaderShrinkAnimation = () => {
	const header = document.querySelector(".header__main");
	if (!header) {
		return;
	}
	const minPos = 200;
	const minPosShrunk = minPos - 37; // Find a good way to calculate the change in header height later
	const cssClass = "header--shrink";
	let timeout = 0;

	window.addEventListener("scroll", () => {
		if (timeout > 0) {
			return;
		}
		timeout = setTimeout(() => {
			const pos = window.scrollY;
			const isShrunk = document.body.classList.contains(cssClass);
			const min = isShrunk ? minPosShrunk : minPos;
			timeout = 0;

			if (pos > min && !isShrunk) {
				document.body.classList.add(cssClass);
			} else if (pos < min && isShrunk) {
				document.body.classList.remove(cssClass);
			}
		}, 250);
	});
};
// #endregion Navigation

// #region Modals

/**
 * To create a modal using this system:
 *  - Add a modal container with an id and the class "modal"
 *  - Add a data-modal attribute to the element that will open the modal on click
 * 		with the same value as the modal's id
 */

const modals = [];
const activeModalClass = "d-block";
const bodyClass = "modal-open";
const exitSelector = ".bx-x, .modal-close";
const openEventName = bodyClass;
window.openEventName = openEventName;
let active;

/**
 * Initializes the event listener for the instructor modal if it exists
 */
const initInstructorModal = () => {
	const modal = document.querySelector("#instructor.modal");

	if (modal) {
		document.addEventListener(openEventName, (e) => {
			const img = modal.querySelector("img");
			const h6 = modal.querySelector("h6");
			const p = modal.querySelector("p");
			let instructor = AoPS.bd.instructors[e.detail.instructor];

			if (!instructor) {
				// TBA details are stored at 0
				// See class.AcademyCourseUtility.php::getInstructorData()
				instructor = AoPS.bd.instructors[0];
			}

			img.src = instructor.image;
			img.setAttribute("alt", instructor.name);
			h6.textContent = instructor.name;
			p.innerHTML = instructor.site_bio;
		});
	}
};

/**
 * Initializes each modal with the corresponding ID to the clicked element's
 * data-modal attribute
 */
const initModals = () => {
	document
		.querySelectorAll("[data-modal]")
		.forEach(function (elem, _idx, _arr) {
			elem.addEventListener("click", handleOpenModalEvent);
			modals[elem.dataset.modal] = document.getElementById(elem.dataset.modal);
			if (modals[elem.dataset.modal]) {
				const exit = modals[elem.dataset.modal].querySelector(exitSelector);
				if (exit) {
					exit.addEventListener("click", onClickCloseHandler);
				}
			}
		});

	initInstructorModal();
};

/**
 * Opens the corresponding modal and closes any open ones; only one modal
 * should be open at any given time
 * @param {MouseEvent} e
 */
window.openModalWithId = (dataset) => {
	const modal = modals[dataset.modal];
	document.body.classList.add(bodyClass);
	if (active) {
		active.classList.remove(activeModalClass);
	}
	active = modal;
	modal.classList.add(activeModalClass);
	if (bsl) {
		bsl.disableBodyScroll(modal);
	}
	document.dispatchEvent(
		new CustomEvent(openEventName, {
			detail: dataset,
		})
	);
	document.addEventListener("click", onClickCloseHandler);
	document.addEventListener("keydown", onKeypressCloseHandler);
};

/**
 * Handle the click event for opening a modal
 * @param {MouseEvent} e
 */
const handleOpenModalEvent = (e) => {
	e.preventDefault();
	if (e.eventPhase !== Event.AT_TARGET) {
		return;
	}
	window.openModalWithId(e.currentTarget.dataset);
};

/**
 * Handler for clicking the X button or the modal shade.
 * @param {MouseEvent} e
 */
const onClickCloseHandler = (e) => {
	if (
		!e.target.closest(exitSelector) &&
		(e.target.closest(".modal__box") ||
			!e.target.closest(".modal, .modal-shade"))
	) {
		return;
	}
	closeModal();
};

/**
 * Handler for pressing the Escape key.
 * @param {KeyboardEvent} e
 */
const onKeypressCloseHandler = (e) => {
	if (e.key !== "Escape") {
		return;
	}
	closeModal();
};

/**
 * Closes every modal; only one modal should be open at any given time
 * @param {MouseEvent} e
 */
const closeModal = () => {
	document.removeEventListener("click", onClickCloseHandler);
	document.removeEventListener("keydown", onKeypressCloseHandler);
	document.body.classList.remove(bodyClass);
	if (active) {
		active.classList.remove(activeModalClass);
		active = null;
	}
	if (bsl) {
		bsl.clearAllBodyScrollLocks();
	}
};
// #endregion Modals

// #region Collapsibles
/**
 * Initialized the collapseable course schedule subject tables
 */
const initCollapseableSchedule = () => {
	const minusIconClass = "bxs-minus-square";
	const headingSel = ".class-schedule__table-heading";
	const headings = document.querySelectorAll(headingSel);

	for (const heading of headings) {
		const icon = heading.querySelector(`.${minusIconClass}`);
		const sibling = heading.nextElementSibling;
		if (!sibling) {
			continue;
		}

		heading.addEventListener("click", () => {
			if (icon) {
				icon.classList.toggle(minusIconClass);
				icon.classList.toggle("bxs-plus-square");
			}
			sibling.classList.toggle("d-none");
		});
	}
};

/**
 * Initializes the panel components that contain a collapsible portion
 */
const initCollapsiblePanels = () => {
	document
		.querySelectorAll(".panel__collapsible")
		.forEach((elem, _idx, _arr) => {
			const panel = elem.closest(".panel");
			const toggle = panel.querySelector(".panel__toggle");
			const target = toggle.querySelector(".panel__icon-target");
			const icon = document.createElement("i");

			icon.classList.add("bx", "bxs-minus-square");
			target.append(icon);

			toggle.addEventListener("click", (_e) => {
				panel.classList.toggle("panel--collapsed");
				icon.classList.toggle("bxs-plus-square");
				icon.classList.toggle("bxs-minus-square");
			});
		});
};

/**
 * A pattern for dropdowns to close when toggled by clicking inside
 * `dropdownSelector` and not in `collapseSelector`
 *
 * @param {string} dropdownSelector The selector to target all dropdowns for
 * initialization
 * @param {string} collapseSelector The selector for the collapsible portion
 * of the dropdown which is not toggleable
 */
const initDropdownFocusPattern = (dropdownSelector, collapseSelector) => {
	document.querySelectorAll(dropdownSelector).forEach((elem, _idx, _arr) => {
		const collapse = elem.querySelector(collapseSelector);
		let isDown = false;
		let isFocused;

		const checkFocus = () => {
			isFocused = elem === document.activeElement;
			if (isFocused) {
				return;
			}
			isFocused = elem.contains(document.activeElement);
		};

		const checkTarget = (e) => {
			checkFocus();
			if (!isFocused) {
				return 1;
			}
			if (e.target === collapse) {
				return 1;
			}
			if (collapse.contains(e.target)) {
				return 1;
			}
			return;
		};

		checkFocus();
		elem.addEventListener("mouseover", checkFocus);
		elem.addEventListener("mouseleave", (_e) => {
			isDown = false;
			checkFocus();
		});
		elem.addEventListener("mousedown", (e) => {
			if (checkTarget(e)) {
				return;
			}
			isDown = true;
		});
		elem.addEventListener("mouseup", (e) => {
			if (!isDown) {
				return;
			}
			if (checkTarget(e)) {
				return;
			}
			document.activeElement.blur(); // Close collapse
			isDown = false;
		});
	});
};

const initCollapseableCoursesSidebar = () => {
	if (!/^\/\/?courses(?:$|\/\/?)/.test(location.pathname)) {
		return;
	}
	const toggles = [...document.querySelectorAll(".sidebar__subtoggle")];
	const activeClass = "js-is-active";
	const storageVar = "coursesSidebarToggleMask";
	const upClass = "bxs-chevron-up";
	const downClass = "bxs-chevron-down";
	const hideClass = "d-none";

	const store = () => {
		const mask = new Bitmask();
		mask.constructMaskFromElements(toggles, (toggle) =>
			toggle.classList.contains(activeClass)
		);
		sessionStorage.setItem(storageVar, mask.mask);
	};

	for (const toggle of toggles) {
		const region = toggle.nextElementSibling;
		if (!(region && region.classList.contains("sidebar__sublinks"))) {
			continue;
		}

		toggle.classList.add("activated");
		toggle.insertAdjacentHTML("beforeend", `<i class="bx ${upClass}"></i>`);
		const icon = toggle.querySelector(`.${upClass}`);
		toggle.addEventListener("click", () => {
			if (icon) {
				icon.classList.toggle(upClass);
				icon.classList.toggle(downClass);
			}
			region.classList.toggle(hideClass);
			toggle.classList.toggle(activeClass);
			store();
		});

		if (innerWidth < lg) {
			if (icon) {
				icon.classList.remove(upClass);
				icon.classList.add(downClass);
			}
			region.classList.add(hideClass);
		}
	}

	if (!toggles.length) {
		return;
	}
	const mask = new Bitmask(sessionStorage.getItem(storageVar));
	mask.iterate(toggles, (toggle) => {
		const region = toggle.nextElementSibling;
		if (!(region && region.classList.contains("sidebar__sublinks"))) {
			return;
		}
		const icon = toggle.querySelector(`.${upClass}`);

		if (icon) {
			icon.classList.remove(upClass);
			icon.classList.add(downClass);
		}
		region.classList.add(hideClass);
		toggle.classList.add(activeClass);
	});
};
// #endregion Collapsibles

// #region Course schedules
/**
 * Enrollment buttons for schedules
 */
const initEnrollment = () => {
	const schedule = document.querySelector(".class-schedule");

	if (schedule) {
		if (AoPS.session.role === "student") {
			schedule.querySelectorAll(".button").forEach((elem) => {
				elem.addEventListener("click", () => {
					alert(
						"You are signed in with a Student Account. You must be signed in with a Parent Account to enroll a student."
					);
				});
			});
			return;
		}

		// TODO Make server conditionally send this JS to the client if the user is admin
		schedule.querySelectorAll(".js-one-time").forEach((elem) => {
			elem.addEventListener("click", (e) => {
				let theClass = e.target.closest("[data-class]");
				if (!theClass) {
					alert("ERROR: Could not find the Class this button enrolls for!");
					return;
				}
				theClass = parseInt(theClass.dataset.class, 10);
				if (!theClass) {
					alert("ERROR: Could not parse Class ID!");
					return;
				}

				// This imitates a jQuery AJAX POST
				fetch("/m/courses/ajax.php", {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
						"X-Requested-With": "XMLHttpRequest",
					},
					body: `a=generate-one-time-link&class_id=${encodeURIComponent(
						theClass
					)}`,
				})
					.then((res) => {
						if (!res.ok) {
							alert(res.status);
							return;
						}

						res
							.json()
							.then((data) => {
								if (data.response.error_code) {
									alert(
										`${data.response.error_code}: ${data.response.error_msg}`
									);
									return;
								}

								prompt(
									"Please copy the one-time enrollment link below to provide to the customer with Ctrl+C or Cmd+C.",
									data.response.url
								);
							})
							.catch(console.error);
					})
					.catch(console.error);
			});
		});
	}
};

// TODO For post-launch, make this a regular, no-JS select (aside from the filter part)
/**
 * Filter for class schedules
 */
const initClassFilter = () => {
	const classSchedule = document.querySelector(
		".class-filters ~ .class-schedule"
	);

	if (classSchedule) {
		const isOpen = (elem) => elem.dataset.status !== "open";
		const toggleOpen = document.getElementById("show-open-classes");
		const selectDay = document.getElementById("course-dotw");
		const label = document.querySelector('label[for="course-dotw"]');
		const defaultLabelText = label.innerText;
		const classes = [...classSchedule.querySelectorAll("[data-class]")];
		const noClasses = document.createElement("div");
		noClasses.classList.add("p-3", "px-lg-4", "no-results");
		noClasses.textContent = "No classes meeting your filters are available.";

		const filter = () => {
			selectDay.blur(); // Close select after changing the value
			let selected = Array.from(selectDay.selectedOptions);
			if (selected.length) {
				label.textContent = selected[0].value;
			} else {
				label.textContent = defaultLabelText;
			}
			selected = selected.map((day) => day.value.toLowerCase());
			// eslint-disable-next-line no-undef
			const openClassesByCourseElem = new Map();

			classes.forEach((elem) => {
				const isNotOpen =
					(toggleOpen.checked && isOpen(elem)) ||
					(selected.length &&
						!selected.some((day) => day === elem.dataset.day || day === "all"));
				let parentArray = openClassesByCourseElem.get(elem.parentElement);
				if (!parentArray) {
					parentArray = openClassesByCourseElem
						.set(elem.parentElement, [])
						.get(elem.parentElement);
				}

				elem.classList.toggle("d-none", isNotOpen);
				if (!isNotOpen) {
					parentArray.push(elem);
				}
			});
			openClassesByCourseElem.forEach((arr, course) => {
				let noClassesClone = course.querySelector(".no-results");
				if (arr.length) {
					if (noClassesClone) {
						noClassesClone.remove();
					}
					arr.forEach((elem, i) => {
						elem.classList.toggle("bg-gray-200", i % 2);
					});

					return;
				}

				if (!noClassesClone) {
					course.append(noClasses.cloneNode(true));
				}
			});
		};

		toggleOpen.addEventListener("change", filter);
		selectDay.addEventListener("change", filter);
	}
};
// #endregion Course schedules

// #region Forms
window.dataLayer = window.dataLayer || [];

/**
 * Initializes the mailing list form
 */
const initMailingList = () => {
	const under13 = document.getElementById("under-13-name");
	const email = document.getElementById("email-address");

	document
		.querySelectorAll('[name="cdid-mailing-list"]')
		.forEach((elem, _key, _list) => {
			elem.setAttribute("value", localStorage.getItem("cdid"));
		});

	if (under13) {
		under13.classList.add("d-none");

		document.querySelectorAll(".i-am input[type=radio]").forEach((elem) => {
			elem.addEventListener("click", (e) => {
				under13.classList.toggle(
					"d-none",
					e.target.value !== "under13-community"
				);
			});
		});
	}

	if (email) {
		email.focus();
	}
};

/**
 * Initialize the Ask Academy form. Does not need to be in a modal
 */
const initAskAcademy = () => {
	const form = document.getElementById("ask-academy");

	if (form) {
		const modalId = "ask";
		const modal = document.getElementById(modalId);
		const blurb = form.querySelector(".ask__blurb");
		const categoryRadioSel = '[name="ask__category"]';
		const subject = document.getElementById("ask__subject");
		const message = document.getElementById("ask__message");
		const name = document.getElementById("ask__name");
		const email = document.getElementById("ask__email");
		const student = document.getElementById("ask__student");
		const user = document.getElementById("ask__user");
		const mail = document.getElementById("ask__mail");

		const onChange = () => {
			let html = "";

			switch (form.querySelector(`${categoryRadioSel}:checked`).value) {
				case "general":
					blurb.classList.remove("d-none");
					html = `Have a general question about ${Academy.campus.name}? Let us know below.`;
					// Hide fields
					student.classList.add("d-none");
					user.classList.add("d-none");
					break;

				case "current":
					blurb.classList.remove("d-none");
					html =
						"Have a question about a current enrollment? Need to send us a message about your child? Please include either your student's name or AoPS username below along with your message.";
					// Show fields
					student.classList.remove("d-none");
					// Hide fields
					user.classList.add("d-none");
					break;

				case "billing":
					blurb.classList.remove("d-none");
					html = "Have a question about billing? Let us know below.";
					// Hide fields
					student.classList.add("d-none");
					user.classList.add("d-none");
					break;

				case "technical":
					blurb.classList.remove("d-none");
					html =
						"Please include a detailed description of the error or issue you are experiencing.";
					// Show fields
					student.classList.remove("d-none");
					user.classList.remove("d-none");
					break;

				default:
					blurb.classList.add("d-none");
					// Hide fields
					student.classList.add("d-none");
					user.classList.add("d-none");
			}

			blurb.innerHTML = html;
		};

		if (modal) {
			document.addEventListener(openEventName, (e) => {
				if (e.detail.modal !== modalId) {
					return;
				}

				subject.focus();
			});
		}

		form.addEventListener(
			"submit",
			(e) => {
				e.preventDefault();
				const type = form.querySelector(`${categoryRadioSel}:checked`).value;
				const mailList = mail.checked;

				fetch("/m/contact/ajax.php", {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
						"X-Requested-With": "XMLHttpRequest",
					},
					body: `a=email&cdid=${encodeURIComponent(
						localStorage.getItem("cdid")
					)}&maillist=${encodeURIComponent(mailList)}&type=${encodeURIComponent(
						type
					)}&subject=${encodeURIComponent(
						subject.value
					)}&url=${encodeURIComponent(
						location.href
					)}&username=${encodeURIComponent(
						email.value
					)}&name=${encodeURIComponent(
						name.value
					)}&student_name=${encodeURIComponent(
						student.value
					)}&message=${encodeURIComponent(message.value)}`,
				})
					.then((res) => {
						if (!res.ok) {
							alert(res.status);
							return;
						}

						res
							.json()
							.then((data) => {
								if (data.response.error_msg) {
									alert(data.response.error_msg); // TODO Do a real alert within the form
									return;
								}

								let role = "not_registered";
								if (AoPS.session.logged_in) {
									const roles = AoPS.session.role.split(",");
									if (roles.includes("parent")) {
										role = "parent";
									} else if (
										roles.includes("officestaff") ||
										roles.includes("admin")
									) {
										role = "staff";
									} else {
										role = "registered_user";
									}
								}
								window.dataLayer.push({
									event: "ask-academy",
									campus: Academy.campus.id,
									contact_type: type,
									joined_maillist: mailList,
									logged_in: AoPS.session.logged_in,
									role: role,
								});

								form.outerHTML = data.response.thanks
									? data.response.thanks
									: `<p>Thank you. We have recieved your comment or question.</p><p class="mb-4">One of our staff members will respond to you within two business days.</p><div class="text-right"><button class="button button--md button--secondary modal-close">OK</button></div>`;
								form
									.querySelector(".modal-close")
									.addEventListener("click", onClickCloseHandler);
							})
							.catch(console.error);
					})
					.catch(console.error);
			},
			{once: true}
		);
		onChange();
		// Change event fires on all radios in a group when one changes
		form.querySelectorAll(categoryRadioSel).forEach((elem) => {
			elem.addEventListener("change", onChange);
		});
	}
};

/**
 * Initialize all forms
 */
const initForm = () => {
	// eslint-disable-next-line no-shadow
	document.querySelectorAll("form").forEach((form) => {
		// Apply invalid styles after the user tries to submit
		// .invalid class should NOT be removed after the user fixes their errors
		form.querySelectorAll("input[required]").forEach((input) => {
			input.addEventListener(
				"invalid",
				() => {
					form.classList.add("invalid");
				},
				{once: true}
			);
		});
	});
};
// #endregion Forms

/**
 * Callback that executes when the DOM becomes interactive; almost all code
 * should be run here, after load/complete, or later
 */
const ready = () => {
	if (document.readyState === "complete") {
		load();
	} else {
		document.addEventListener("readystatechange", load, {
			once: true,
		});
	}

	initSidebarToggle();
	initHeaderToggle();
	initMobileLinkToggle();
	initInfobars();
	initModals();
	initCollapsiblePanels();
	initDropdownFocusPattern(".round-dropdown", ".round-dropdown__collapsible");
	initEnrollment();
	initDropdownFocusPattern(".select", "select");
	initClassFilter();
	initMailingList();
	initAskAcademy();
	initForm();
	initCollapseableSchedule();
	initCollapseableCoursesSidebar();

	initSliders(".slider"); // about page sliders
	initSliders(".testimonials__slider"); // homepage testimonial slider
};

const load = () => {
	initHeaderShrinkAnimation();
};

if (document.readyState !== "loading") {
	ready();
} else {
	document.addEventListener("readystatechange", ready, {
		once: true,
	});
}
